import { SeatConfiguration, SeatInfo, SeatSelectionState, Traveller } from '../charter.types';

export const hasInfantTraveller = (travellers: Array<Traveller>): boolean =>
  travellers.some((pnrTraveller) => pnrTraveller.passengerType === 'INF');

export const isBassinetSeatAvailable = (seat: SeatInfo, travellers: Array<Traveller>): boolean =>
  seat.blockReason === 'bassinet' && hasInfantTraveller(travellers);

export const isSeatAvailableForBooking = (seat: SeatInfo | undefined, travellers: Array<Traveller>): boolean =>
  Boolean(seat && (seat.isAvailable || isBassinetSeatAvailable(seat, travellers)));

export const determineSeatAvailability = (
  seat: SeatInfo,
  traveller: Traveller,
  travellers: Array<Traveller>,
  seatSelections: SeatSelectionState,
  flightId: string,
  configuration: SeatConfiguration,
) => {
  const hasInfantInBooking = hasInfantTraveller(travellers);
  if (!isSeatAvailableForBooking(seat, travellers)) {
    return false;
  }

  const seatLetter = seat.seatId.slice(-1);
  const seatRow = seat.seatId.slice(0, -1);
  const emergencySeatPartners = configuration.emergencySeatPartners;
  const isEmergencyRowSeat = seat.feature.isExitRow;
  const isEmergencySideSeat = isEmergencyRowSeat && Boolean(emergencySeatPartners[seatLetter]);
  if (traveller.passengerType === 'INF') {
    return false;
  }

  if (traveller.passengerType === 'CHD' && isEmergencySideSeat) {
    const companionSeatLetter = emergencySeatPartners[seatLetter];
    const companionSeatId = companionSeatLetter ? `${seatRow}${companionSeatLetter}` : null;

    if (!companionSeatId) {
      return false;
    }

    const hasGuardianOnCompanionSeat = travellers
      .filter((pnrTraveller) => pnrTraveller.passengerType === 'ADT')
      .some((adultTraveller) => (seatSelections[flightId]?.[adultTraveller.id] ?? null) === companionSeatId);

    if (!hasGuardianOnCompanionSeat) {
      return false;
    }
  }

  if (traveller.passengerType === 'ADT' && hasInfantInBooking && isEmergencySideSeat) {
    return false;
  }

  return true;
};
